import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';
import { RentalObjectCategory } from './const/enums';

export interface LettingFeatureUsageCategory {
  category: RentalObjectCategory;
  count: number;
}

export interface LettingFeatureUsageRentalObject {
  id: string;
  rentalId: string;
  street: string;
  isIncluded: boolean;
}

export class LettingFeatureAdmin extends ModelBase {
  constructor(context?: any) {
    super();
    this.id = context?.id;
    this.phrase = context?.phrase ?? [];
    this.isActive = context?.isActive ?? true;
  }

  phrase: Translation[];
  isActive: boolean;

  get caption(): string {
    return this.phrase.find(x => x.cultureName === 'sv-SE')?.translationText ?? this.phrase.find(x => !!x.translationText)?.translationText ?? '';
  }

  get hasEnglishTranslation(): boolean {
    return this.phrase.some(x => x.cultureName?.toLowerCase() === 'en-gb' && !!x.translationText?.trim());
  }

  override toString(culture?: string): string {
    return (
      this.phrase.find(x => x.cultureName === culture)?.translationText ??
      this.phrase.find(x => x.cultureName === 'sv-SE')?.translationText ??
      this.phrase.find(x => !!x.translationText)?.translationText ??
      ''
    );
  }
}
